import React, { useEffect, useState } from "react";
import clsx from "clsx";

import { getReadable, replaceTabName } from "../../../libs/talk";

import { TalkCategory } from "../../../services/talkServices";

import { useSandiTalk } from "../../../contexts/boardContext";
import { useUserContext } from "../../../contexts/userContext";

import HorizontalRule from "../../Rule/Horizontal";
import CategoryListPopup from "../../Popup/CategoryList";
import SimplePopup from "../../Popup/Simple";

type Props = {
  tabs: TalkCategory[];
  type?: string;
};

export default function BoardTab({ tabs, type }: Props) {
  const [talk, { updateCategory }] = useSandiTalk();
  const [popup, setPopup] = useState<"noCategory" | "categoryList" | "">("");
  const middleTabs = tabs.find(
    (item) => item.alias === talk.largeCategory?.alias
  )?.lifeCategoryList;
  const scrollRef = React.useRef<HTMLDivElement>(null);
  const [user] = useUserContext();

  const handleTabClick = (tab: TalkCategory) => {
    if (
      tab.lifeCategoryList?.filter((category) => category.name !== "전체")
        .length === 0 ||
      !talk.buildingId
    ) {
      setPopup("noCategory");
      return;
    }

    updateCategory({
      categoryInfo: {
        largeCategory: tab,
        middleCategory: tab.lifeCategoryList?.[0],
      },
    });
  };

  const handleCategoryClick = (tab: TalkCategory) => {
    updateCategory({
      categoryInfo: {
        middleCategory: tab,
      },
    });
  };

  useEffect(() => {
    document
      .getElementById(`category-${talk.middleCategory?.lifeCategoryId}`)
      ?.scrollIntoView();
  }, [talk.middleCategory]);

  useEffect(() => {}, [talk.largeCategory, tabs]);

  return (
    <div className="overflow-x-auto w-full" data-testid="board-tab-wrapper">
      {type !== "search" && (
        <>
          <div className="px-5" data-testid="board-tab-large-category">
            <ul
              className="w-full grid"
              style={{
                gridTemplateColumns: `repeat(${tabs.length}, minmax(0, 1fr))`,
              }}
            >
              {tabs.map((tab) => (
                <li
                  key={tab.lifeCategoryId}
                  className={`w-full flex justify-center relative ${
                    talk.largeCategory?.lifeCategoryId === tab?.lifeCategoryId
                      ? "text-black font-bold"
                      : "text-gray-500"
                  }`}
                  onClick={() => {
                    handleTabClick(tab);
                    scrollRef.current?.scrollTo(0, 0);
                  }}
                >
                  <button className={`focus:outline-none py-2`}>
                    {replaceTabName(tab?.name ?? "")}
                  </button>
                  {talk.largeCategory?.lifeCategoryId ===
                    tab?.lifeCategoryId && (
                    <div className="bg-brand-primary-magenta h-[2px] w-full absolute bottom-0"></div>
                  )}
                </li>
              ))}
            </ul>
          </div>
          <HorizontalRule margin={"0px"} />
        </>
      )}
      <div className="flex items-center py-4 px-5 justify-between relative">
        <div className=" overflow-scroll w-[calc(100vw-72px)]" ref={scrollRef}>
          <div className="flex items-center gap-2">
            {middleTabs
              ?.filter((item) => getReadable(item, user))
              .map((category: TalkCategory) => (
                <div
                  key={category.lifeCategoryId}
                  className={clsx([
                    "border rounded-full py-1 px-3 cursor-pointer whitespace-nowrap",
                    {
                      "bg-brand-primary-magenta text-white font-semibold border-brand-primary-magenta":
                        talk.middleCategory?.lifeCategoryId ===
                        category.lifeCategoryId,
                      "border-brand-gray-10 border-opacity-10 text-brand-neutral-40":
                        talk.middleCategory?.lifeCategoryId !==
                        category.lifeCategoryId,
                    },
                  ])}
                  onClick={() => handleCategoryClick(category)}
                  id={`category-${category.lifeCategoryId}`}
                >
                  {category.name}
                </div>
              ))}
            {/* <div className="min-w-[32px] min-h-[34px]"></div> */}
          </div>
        </div>
        <div className="absolute right-5 top-1/2 -translate-y-1/2 flex items-center">
          <div className="h-[34px] w-5 bg-board-tab-linear"></div>
          <div
            className="text-xl h-[34px] bg-white"
            onClick={() => setPopup("categoryList")}
          >
            <TabCategoryIcon />
          </div>
        </div>
      </div>
      <HorizontalRule margin={"0px"} />

      <SimplePopup
        message="등록된 게시판이 없습니다."
        isOpen={popup === "noCategory"}
        onClose={() => setPopup("")}
      />
      <CategoryListPopup
        isOpen={popup === "categoryList"}
        onClose={() => setPopup("")}
      />
    </div>
  );
}

export const TabCategoryIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="32" height="32" fill="white" />
    <path d="M13.1758 16H24.8225" stroke="#1D1929" strokeWidth="1.75" />
    <path d="M18.1758 23H24.8225" stroke="#1D1929" strokeWidth="1.75" />
    <path d="M7.17578 9H24.8225" stroke="#1D1929" strokeWidth="1.75" />
  </svg>
);
